import React from 'react';
import { BulbFilled, BulbOutlined, DesktopOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { useTheme } from '../../context/ThemeContext';

// This version of @ant-design/icons lacks Sun/Moon — bulb filled (on) for
// light, bulb outlined (off) for dark, desktop for system auto.
const ICON = {
    light: <BulbFilled />,
    dark: <BulbOutlined />,
    system: <DesktopOutlined />
};

const LABEL = {
    light: 'Light',
    dark: 'Dark',
    system: 'System'
};

export const ThemeToggle = () => {
    const { mode, resolved, setMode } = useTheme();

    const items = [
        { key: 'light', label: 'Light', icon: ICON.light },
        { key: 'dark', label: 'Dark', icon: ICON.dark },
        { key: 'system', label: 'System', icon: ICON.system }
    ].map((i) => ({ ...i, label: mode === i.key ? `${i.label} ✓` : i.label }));

    return (
        <Dropdown
            menu={{
                items,
                selectable: true,
                selectedKeys: [mode],
                onClick: ({ key }) => setMode(key)
            }}
            trigger={['click']}
            placement='bottomRight'
        >
            <Tooltip title={`Theme: ${LABEL[mode]} (showing ${resolved})`}>
                <Button
                    type='text'
                    size='small'
                    icon={ICON[mode]}
                    aria-label={`Theme: ${LABEL[mode]}. Click to change.`}
                    style={{ marginRight: 4 }}
                />
            </Tooltip>
        </Dropdown>
    );
};
